import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// styles
import { screen } from 'components/styles/variables';
import { columnStyles } from 'components/styles/comparisons';

export default function VehiclePhotos({ vehicle1, vehicle2 }) {
  const { t } = useTranslation();
  return (
    <div className="columns">
      <div className="column">
        <img src={vehicle1.photo_url} className="photo" />
        <h2 className="title">
          {t('comparison.ymm', {
            make: vehicle1.make,
            model: vehicle1.model,
            year: vehicle1.year,
          })}
        </h2>
      </div>
      <div className="column">
        <img src={vehicle2.photo_url} className="photo" />
        <h2 className="title">
          {t('comparison.ymm', {
            make: vehicle2.make,
            model: vehicle2.model,
            year: vehicle2.year,
          })}
        </h2>
      </div>
      <style jsx>{columnStyles}</style>
      <style jsx>{`
        .columns {
          margin-top: 50px;
        }

        @media (min-width: ${screen.smMin}) {
          margin-top: 0;
        }

        .photo {
          width: 100%;
        }

        .title {
          margin: 15px 0;
          font-size: 26px;
          line-height: 26px;
        }

        @media (min-width: ${screen.smMin}) {
          .title {
            font-size: 36px;
            line-height: 36px;
          }
        }
      `}</style>
    </div>
  );
}
VehiclePhotos.propTypes = {
  vehicle1: PropTypes.object,
  vehicle2: PropTypes.object,
};
